export default __webpack_public_path__ + "static/media/goldStar.a78d454e.svg";